import { useState } from "react";
import { post } from "../api";

type PreviewStartResponse = { ok: true; checkinUrl: string };

export function PreviewPage() {
  const [working, setWorking] = useState(false);
  const [error, setError] = useState("");

  async function startStudentPreview() {
    setWorking(true);
    setError("");
    try {
      const result = await post<PreviewStartResponse>("/api/preview/start", {});
      window.location.assign(result.checkinUrl);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : "Preview could not be started.");
      setWorking(false);
    }
  }

  return <main className="preview-page">
    <section className="preview-shell">
      <header className="preview-heading">
        <img src="/logo.png" alt="Assemble Studio" />
        <div>
          <span className="preview-kicker">LOCAL PREVIEW</span>
          <h1>Attendance system review</h1>
          <p>Safe demo data only. No production database or email delivery is connected.</p>
        </div>
      </header>

      {error && <p className="preview-error" role="alert">{error}</p>}

      <section className="preview-primary" aria-labelledby="student-preview-title">
        <div>
          <span className="preview-step">Recommended first step</span>
          <h2 id="student-preview-title">Scan-to-check-in journey</h2>
          <p>Connect this browser as demo student Amelia, then review the live class confirmation and pass deduction flow.</p>
        </div>
        <button onClick={startStudentPreview} disabled={working}>
          {working ? "Preparing demo..." : "Start student check-in"}
        </button>
      </section>

      <div className="preview-grid">
        <PreviewLink to="/me" label="Student records" detail="Pass balance, attendance history and renewal prompt." />
        <PreviewLink to="/admin" label="Teacher dashboard" detail="Today's sessions, students, passes, reminders and audit trail." />
        <PreviewLink to="/display/session_demo_jazz" label="Classroom QR" detail="Live rotating QR challenge, backup code and countdown." external />
        <PreviewLink to="/" label="Student landing" detail="Class-code entry and device recovery without a scanned QR." />
      </div>

      <footer className="preview-notes">
        <strong>Preview boundary</strong>
        <p>All changes stay inside <code>.preview-state</code> on this computer. Reopening the launcher keeps the isolated sample records available without touching Cloudflare.</p>
      </footer>
    </section>
  </main>;
}

function PreviewLink({ to, label, detail, external = false }: { to: string; label: string; detail: string; external?: boolean }) {
  return <a className="preview-card" href={to} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined}>
    <span>{label}</span>
    <p>{detail}</p>
    <strong>{external ? "Open in new tab ↗" : "Open preview →"}</strong>
  </a>;
}